import { rest } from "src/common/rest";
import { apiObjUrl } from "src/common/apiUrl";
import { isAxiosError } from "axios";
import { ZUid } from "src/types/zUid";
import { FileType, zUploadResult, zImportStatus } from "./types";

export const uploadEntityFile = async (objectId: ZUid, file: FileType) => {
  const formData = new FormData();
  formData.set("file", file);
  try {
    const { data } = await rest.post(
      apiObjUrl(`/objects/${objectId}/upload`),
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "*/*",
        },
        translate: true,
      },
    );
    return zUploadResult.parse(data);
  } catch (e) {
    if (isAxiosError(e) && e.status === 400) {
      return zUploadResult.parse(e.response?.data);
    }
    throw e;
  }
};

export const checkImportStatus = async () => {
  const { data } = await rest.get(apiObjUrl(`/objects/import/status`));
  if (!data) return null;
  return zImportStatus.parse(data);
};
